import { useCallback } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

const kPaymentMethodToken = 'paymentMethodToken';

export function usePaymentMethodToken() {
  const savePaymentMethodToken = useCallback(async (token: string) => {
    return AsyncStorage.setItem(kPaymentMethodToken, token);
  }, []);

  const getPaymentMethodToken = useCallback(async () => {
    return AsyncStorage.getItem(kPaymentMethodToken);
  }, []);

  const removePaymentMethodToken = useCallback(async () => {
    return AsyncStorage.removeItem(kPaymentMethodToken);
  }, []);

  return {
    savePaymentMethodToken,
    getPaymentMethodToken,
    removePaymentMethodToken,
  };
}
